import { IDataGridDefinition, IDataGridButtonEvent } from './../../../interfaces/data-grid.interface';
import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterContentInit, ContentChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { SiuTemplateDirective } from '../../../directives/siu-template.directive';

@Component({
  selector: 'bandeja-list-grid',
  templateUrl: './bandeja-list-grid.component.html',
  styleUrls: [ './bandeja-list-grid.component.scss' ]
})
export class BandejaListGridComponent implements OnInit, OnChanges, AfterContentInit {

  @Input() loading: boolean;
  @Input() emptyRowsMsg: string = 'No se encontraron resultados';
  @Input() definition: IDataGridDefinition;
  @Input() source: any[];
  @Input() elevation: number = 8;
  @Input() showSearch: boolean = true;
  @ContentChildren(SiuTemplateDirective) templates: QueryList<SiuTemplateDirective>;
  @Output('on-click-button') onClickButtonEvent: EventEmitter<IDataGridButtonEvent> = new EventEmitter();

  dataSource: MatTableDataSource<any>;
  customTemplates: any = {};
  displayedColumns: string[];

  constructor() { }

  ngOnInit() {
    if (!this.source) {
      console.error('siu-list-grid error: "source" no puede ser null');
      return false;
    }
    this.displayedColumns = this.definition.columns.map(x => x.field);
  }

  ngAfterContentInit(): void {
    const customColumns = this.definition.columns.filter(x => x.template);

    if (customColumns.length > 0) {
      customColumns.forEach(x => {
        const matches = this.templates.filter(temp => temp.getType() == x.field);
        if (matches.length > 0) {
          this.customTemplates[ x.field ] = matches[ 0 ].template;
        }
      });
    }

    const templateToolbarRight = this.templates.find(temp => temp.getType() == 'grid-toolbar-right');
    if (templateToolbarRight) {
      this.customTemplates[ 'grid-toolbar-right' ] = templateToolbarRight.template;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.source && changes.source.currentValue)
      this.dataSource = new MatTableDataSource(this.source);
  }

  handleFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  handleClickButton = (event, item, index) => {
    this.onClickButtonEvent.emit({ item, action: event.action, index });
  }

}
